module.exports = __webpack_public_path__ + "static/media/percentage-searches-on-mobile-devices-2.e8c1eaa3.webp";